<med-button id="logout" (click)="logout()" size="small" color="primary" button-type="flat">
    <span class="button-label">{{ 'logout' | translate }}</span>
</med-button>
